import { render } from "./ElementList.vue?vue&type=template&id=280dfbe9&scoped=true&ts=true"
import script from "./ElementList.vue?vue&type=script&lang=ts"
export * from "./ElementList.vue?vue&type=script&lang=ts"

import "./ElementList.vue?vue&type=style&index=0&id=280dfbe9&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280dfbe9"]])

export default __exports__